import { render, staticRenderFns } from "./IconNotification.vue?vue&type=template&id=4ab73bcb&scoped=true&"
import script from "./IconNotification.vue?vue&type=script&lang=js&"
export * from "./IconNotification.vue?vue&type=script&lang=js&"
import style0 from "./IconNotification.vue?vue&type=style&index=0&id=4ab73bcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab73bcb",
  null
  
)

export default component.exports